// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   LinearProgress,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminDailyCourtCasesComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedCase, setSelectedCase] = useState(null);

//   const [formData, setFormData] = useState({
//     case_no: '',
//     kpid_sec: '',
//     petitioner: '',
//     respondants: '',
//     status: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteCase, setDeleteCase] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'case_no', field: 'case_no', headerName: 'Case No.', width: 130 },
//     { id: 'kpid_sec', field: 'kpid_sec', headerName: 'KP ID/Section', width: 130 },
//     { id: 'petitioner', field: 'petitioner', headerName: 'Petitioner', width: 150 },
//     { id: 'respondants', field: 'respondants', headerName: 'Respondants', width: 150 },
//     { id: 'status', field: 'status', headerName: 'Status', width: 120 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">Download</a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchCases();
//   }, []);

//   const fetchCases = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           kpid_sec: item.kpid_sec,
//           petitioner: item.petitioner,
//           respondants: item.respondants,
//           status: item.status,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily court cases:', error);
//         setSnackbarMessage('Failed to load Daily Court Cases data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddCase = () => {
//     setIsEditMode(false);
//     setFormData({
//       case_no: '',
//       kpid_sec: '',
//       petitioner: '',
//       respondants: '',
//       status: '',
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (courtCase) => {
//     setIsEditMode(true);
//     setSelectedCase(courtCase);
//     setFormData({
//       case_no: courtCase.case_no,
//       kpid_sec: courtCase.kpid_sec,
//       petitioner: courtCase.petitioner,
//       respondants: courtCase.respondants,
//       status: courtCase.status,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (courtCase) => {
//     setDeleteCase(courtCase);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/daily-court-orders/${deleteCase.id}/`)
//       .then(() => {
//         setSnackbarMessage('Daily Court Case deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchCases();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete Daily Court Case.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteCase(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.case_no) errors.case_no = 'Case No. is required';
//     if (!formData.kpid_sec) errors.kpid_sec = 'KP ID/Section is required';
//     if (!formData.petitioner) errors.petitioner = 'Petitioner is required';
//     if (!formData.respondants) errors.respondants = 'Respondants is required';
//     if (!formData.status) errors.status = 'Status is required';
//     // File is now optional, so no required validation for file here

//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors(prev => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors(prev => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('case_no', formData.case_no);
//     form.append('kpid_sec', formData.kpid_sec);
//     form.append('petitioner', formData.petitioner);
//     form.append('respondants', formData.respondants);
//     form.append('status', formData.status);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(
//           `${API_BASE_URL}/home-notification/daily-court-orders/${selectedCase.id}/`,
//           form,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (e) => {
//               setUploadProgress(Math.round((e.loaded * 100) / e.total));
//             },
//           }
//         );
//         setSnackbarMessage('Daily Court Case updated successfully.');
//       } else {
//         await api.post(
//           `${API_BASE_URL}/home-notification/daily-court-orders/`,
//           form,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (e) => {
//               setUploadProgress(Math.round((e.loaded * 100) / e.total));
//             },
//           }
//         );
//         setSnackbarMessage('Daily Court Case added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchCases();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit Daily Court Case.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Daily Court Cases
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddCase} disabled={uploading}>
//           Add Case
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Daily Court Case' : 'Add Daily Court Case'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Case No."
//             type="text"
//             fullWidth
//             value={formData.case_no}
//             error={!!formErrors.case_no}
//             helperText={formErrors.case_no}
//             onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="KP ID/Section"
//             type="text"
//             fullWidth
//             value={formData.kpid_sec}
//             error={!!formErrors.kpid_sec}
//             helperText={formErrors.kpid_sec}
//             onChange={(e) => setFormData({ ...formData, kpid_sec: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Petitioner"
//             type="text"
//             fullWidth
//             value={formData.petitioner}
//             error={!!formErrors.petitioner}
//             helperText={formErrors.petitioner}
//             onChange={(e) => setFormData({ ...formData, petitioner: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Respondants"
//             type="text"
//             fullWidth
//             value={formData.respondants}
//             error={!!formErrors.respondants}
//             helperText={formErrors.respondants}
//             onChange={(e) => setFormData({ ...formData, respondants: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Status"
//             type="text"
//             fullWidth
//             value={formData.status}
//             error={!!formErrors.status}
//             helperText={formErrors.status}
//             onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//             disabled={uploading}
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error">
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedCase?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedCase.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
//             {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this Daily Court Case?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress, Grid,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminDailyCourtCasesComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);

  const [formData, setFormData] = useState({
    case_no: '',
    kpid_sec: '',
    petitioner: '',
    respondants: '',
    date_of_filling: '',
    previous_date_of_hearing: '',
    next_date_of_hearing: '',
    advocate_name: '',
    appearence_by: '',
    status: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteCase, setDeleteCase] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'case_no', field: 'case_no', headerName: 'Case No.', width: 130 },
    { id: 'kpid_sec', field: 'kpid_sec', headerName: 'KP ID/Section', width: 130 },
    { id: 'petitioner', field: 'petitioner', headerName: 'Petitioner', width: 150 },
    { id: 'respondants', field: 'respondants', headerName: 'Respondants', width: 150 },
    { 
      id: 'date_of_filling', 
      field: 'date_of_filling', 
      headerName: 'Date of Filing', 
      width: 120 
    },
    { 
      id: 'previous_date_of_hearing', 
      field: 'previous_date_of_hearing', 
      headerName: 'Prev Hearing', 
      width: 120 
    },
    { 
      id: 'next_date_of_hearing', 
      field: 'next_date_of_hearing', 
      headerName: 'Next Hearing', 
      width: 120 
    },
    { 
      id: 'advocate_name', 
      field: 'advocate_name', 
      headerName: 'Advocate Name', 
      width: 140 
    },
    { 
      id: 'appearence_by', 
      field: 'appearence_by', 
      headerName: 'Appearance By', 
      width: 140 
    },
    { id: 'status', field: 'status', headerName: 'Status', width: 120 },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
            Download
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchCases();
  }, []);

  const fetchCases = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          kpid_sec: item.kpid_sec,
          petitioner: item.petitioner,
          respondants: item.respondants,
          date_of_filling: item.date_of_filling,
          previous_date_of_hearing: item.previous_date_of_hearing,
          next_date_of_hearing: item.next_date_of_hearing,
          advocate_name: item.advocate_name,
          appearence_by: item.appearence_by,
          status: item.status,
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch daily court cases:', error);
        setSnackbarMessage('Failed to load Daily Court Cases data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddCase = () => {
    setIsEditMode(false);
    setFormData({
      case_no: '',
      kpid_sec: '',
      petitioner: '',
      respondants: '',
      date_of_filling: '',
      previous_date_of_hearing: '',
      next_date_of_hearing: '',
      advocate_name: '',
      appearence_by: '',
      status: '',
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (courtCase) => {
    setIsEditMode(true);
    setSelectedCase(courtCase);
    setFormData({
      case_no: courtCase.case_no,
      kpid_sec: courtCase.kpid_sec,
      petitioner: courtCase.petitioner,
      respondants: courtCase.respondants,
      date_of_filling: courtCase.date_of_filling || '',
      previous_date_of_hearing: courtCase.previous_date_of_hearing || '',
      next_date_of_hearing: courtCase.next_date_of_hearing || '',
      advocate_name: courtCase.advocate_name || '',
      appearence_by: courtCase.appearence_by || '',
      status: courtCase.status,
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (courtCase) => {
    setDeleteCase(courtCase);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/daily-court-orders/${deleteCase.id}/`)
      .then(() => {
        setSnackbarMessage('Daily Court Case deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchCases();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete Daily Court Case.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteCase(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.case_no) errors.case_no = 'Case No. is required';
    if (!formData.kpid_sec) errors.kpid_sec = 'KP ID/Section is required';
    if (!formData.petitioner) errors.petitioner = 'Petitioner is required';
    if (!formData.respondants) errors.respondants = 'Respondants is required';
    if (!formData.status) errors.status = 'Status is required';

    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) errors.file = 'File size must be less than 10MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file && file.size > 10 * 1024 * 1024) {
  //     setFormErrors(prev => ({ ...prev, file: 'File size must be less than 10MB' }));
  //     setSelectedFile(null);
  //   } else {
  //     setFormErrors(prev => ({ ...prev, file: null }));
  //     setSelectedFile(file);
  //   }
  // };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  
  if (!file) {
    setFormErrors(prev => ({ ...prev, file: null }));
    setSelectedFile(null);
    return;
  }
  
  // Check PDF type first
  const isPdf = file.type === 'application/pdf' || 
                file.name.toLowerCase().endsWith('.pdf');
  if (!isPdf) {
    setFormErrors(prev => ({ ...prev, file: 'Only PDF files are allowed' }));
    setSelectedFile(null);
    e.target.value = ''; // Clear input
    return;
  }
  
  // Check file size
  if (file.size > 10 * 1024 * 1024) {
    setFormErrors(prev => ({ ...prev, file: 'File size must be less than 10MB' }));
    setSelectedFile(null);
    e.target.value = ''; // Clear input
    return;
  }
  
  // Valid file
  setFormErrors(prev => ({ ...prev, file: null }));
  setSelectedFile(file);
};

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('case_no', formData.case_no);
    form.append('kpid_sec', formData.kpid_sec);
    form.append('petitioner', formData.petitioner);
    form.append('respondants', formData.respondants);
    form.append('date_of_filling', formData.date_of_filling);
    form.append('previous_date_of_hearing', formData.previous_date_of_hearing);
    form.append('next_date_of_hearing', formData.next_date_of_hearing);
    form.append('advocate_name', formData.advocate_name);
    form.append('appearence_by', formData.appearence_by);
    form.append('status', formData.status);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(
          `/home-notification/daily-court-orders/${selectedCase.id}/`,
          form,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => {
              setUploadProgress(Math.round((e.loaded * 100) / e.total));
            },
          }
        );
        setSnackbarMessage('Daily Court Case updated successfully.');
      } else {
        await api.post(
          `/home-notification/daily-court-orders/`,
          form,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => {
              setUploadProgress(Math.round((e.loaded * 100) / e.total));
            },
          }
        );
        setSnackbarMessage('Daily Court Case added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchCases();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit Daily Court Case.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Daily Court Cases
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddCase} disabled={uploading}>
          Add Case
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Daily Court Case' : 'Add Daily Court Case'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="Case No."
                type="text"
                fullWidth
                value={formData.case_no}
                error={!!formErrors.case_no}
                helperText={formErrors.case_no}
                onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="KP ID/Section"
                type="text"
                fullWidth
                value={formData.kpid_sec}
                error={!!formErrors.kpid_sec}
                helperText={formErrors.kpid_sec}
                onChange={(e) => setFormData({ ...formData, kpid_sec: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                label="Petitioner"
                type="text"
                fullWidth
                value={formData.petitioner}
                error={!!formErrors.petitioner}
                helperText={formErrors.petitioner}
                onChange={(e) => setFormData({ ...formData, petitioner: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                label="Respondants"
                type="text"
                fullWidth
                value={formData.respondants}
                error={!!formErrors.respondants}
                helperText={formErrors.respondants}
                onChange={(e) => setFormData({ ...formData, respondants: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                label="Date of Filing"
                type="date"
                fullWidth
                value={formData.date_of_filling}
                onChange={(e) => setFormData({ ...formData, date_of_filling: e.target.value })}
                InputLabelProps={{ shrink: true }}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                label="Previous Hearing Date"
                type="date"
                fullWidth
                value={formData.previous_date_of_hearing}
                onChange={(e) => setFormData({ ...formData, previous_date_of_hearing: e.target.value })}
                InputLabelProps={{ shrink: true }}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                label="Next Hearing Date"
                type="date"
                fullWidth
                value={formData.next_date_of_hearing}
                onChange={(e) => setFormData({ ...formData, next_date_of_hearing: e.target.value })}
                InputLabelProps={{ shrink: true }}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="Advocate Name"
                type="text"
                fullWidth
                value={formData.advocate_name}
                onChange={(e) => setFormData({ ...formData, advocate_name: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="Appearance By"
                type="text"
                fullWidth
                value={formData.appearence_by}
                onChange={(e) => setFormData({ ...formData, appearence_by: e.target.value })}
                disabled={uploading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                label="Status"
                type="text"
                fullWidth
                value={formData.status}
                error={!!formErrors.status}
                helperText={formErrors.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                disabled={uploading}
              />
            </Grid>
          </Grid>

          <Box mt={3}>
            <Typography variant="subtitle2" gutterBottom>File Upload (Optional)</Typography>
            <input
              accept="*"
              style={{ display: 'block', marginTop: '8px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error">
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedCase?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={selectedCase.links} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>

          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this Daily Court Case?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
